import { createFileRoute } from "@tanstack/react-router";

import { RecepturaProtocolsPage } from "@/features/receptura/protocols-page";
import { ensureElementVisible } from "@/lib/route-guards";

interface ProtokolySearch {
	/** Filtr „protokoły utworzone z szablonu" — link z licznika w receptariuszu. */
	templateId?: number;
}

export const Route = createFileRoute("/_auth/receptura/protokoly")({
	component: ProtokolyRoute,
	validateSearch: (search: Record<string, unknown>): ProtokolySearch => ({
		templateId:
			search.templateId != null && !Number.isNaN(Number(search.templateId))
				? Number(search.templateId)
				: undefined,
	}),
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.receptura.protokoly",
			location.pathname,
		);
	},
});

function ProtokolyRoute() {
	const { templateId } = Route.useSearch();
	return <RecepturaProtocolsPage templateIdFilter={templateId} />;
}
